import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import cx from 'classnames';
import segmentLabelMap from 'sharedParts/config/segmentLabelMap';
import personalLabelMap from 'sharedParts/config/personalLabelMap';

import styles from './RatingNumeric.scss';
import RatingNumericItem from '../RatingNumericItem';
import { getMirroredValue } from '../../../../utils/getMirroredValue';

const getGridTemplateColumnsStyle = (itemListLength, segmentType, shape) => {
  if (segmentType === segmentLabelMap.noSegment) {
    if (shape === 'rectangle' && itemListLength <= 5) {
      return styles['five-columns-grid'];
    }
    return styles['ten-columns-grid'];
  }
  if (segmentType === segmentLabelMap.itemList) {
    if (itemListLength > 10) return styles['six-columns-grid'];
    return styles['five-columns-grid'];
  }
  if (itemListLength <= 5) return styles['five-columns-grid'];
  if (itemListLength > 10) return styles['eleven-columns-grid'];
  return styles['ten-columns-grid'];
};

const RatingNumeric = (props) => {
  const {
    iconList,
    labelType,
    max,
    min,
    segmentLabelList,
    size,
    shape,
    initialValue = null,
    onChange = noop,
    readOnly,
    className,
    containerClassName,
    segmentType,
  } = props;

  const normalizeMin = (min) => (min === -1 ? 0 : 1);

  const normalizeValue = (value) => {
    return labelType === personalLabelMap.numberDesc
      ? getMirroredValue({
          value,
          min,
          max,
          normalizeFn: normalizeMin,
        })
      : value;
  };

  const [selectedValue, setSelectedValue] = useState(normalizeValue(initialValue));
  const [selectedIndex, setSelectedIndex] = useState(initialValue ? selectedValue - 1 : -1);

  const handleChange = ({ index, value }) => {
    if (readOnly) return;
    setSelectedIndex(index);
    const normalizedValue = normalizeValue(value);
    setSelectedValue(normalizedValue);
    onChange(normalizedValue);
  };

  const isItemSelected = (itemIndex) => itemIndex === selectedIndex;

  return (
    <div
      className={cx(
        className,
        containerClassName,
        styles['rating-numeric-container'],
        segmentType === segmentLabelMap.noSegment && styles['no-segment'],
        styles[size],
        getGridTemplateColumnsStyle(iconList.full.length, segmentType, shape),
      )}
    >
      {iconList.full.map((item, index) => (
        <RatingNumericItem
          key={index}
          full={item}
          empty={iconList.empty[index]}
          isItemSelected={isItemSelected(index)}
          handleChange={handleChange}
          index={index}
          value={index + 1}
          segmentType={segmentType}
          segmentLabelList={segmentLabelList}
          {...props}
        />
      ))}
    </div>
  );
};

RatingNumeric.propTypes = {
  initialValue: PropTypes.number,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  iconList: PropTypes.any,
  segmentLabelList: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, value: PropTypes.string })),
  size: PropTypes.string,
  shape: PropTypes.string,
  max: PropTypes.number,
  min: PropTypes.number,
  labelType: PropTypes.string,
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  segmentType: PropTypes.string,
};

export default RatingNumeric;
